import { useFormContext } from "react-hook-form";
import Fein from "../../../gdk/Fein";

export default function FeinField() {
    const { control, watch } = useFormContext();
    const watchSoleProprietor = watch("soleProprietor");

    return (
        <div className="flex-row">
            <Fein
                control={control}
                name="fein"
                label={
                    <>
                        Agency Federal Employer Identification Number (FEIN)
                        {watchSoleProprietor !== "true" ? <span className="required">*</span> : ""}
                    </>
                }
            />
        </div>
    );
}
